import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  Output,
} from '@angular/core';
import { Subject, combineLatest, debounceTime } from 'rxjs';
import { IModule } from 'src/app/interfaces/IModule';
import { LaboratoryFileService } from 'src/app/services/laboratoryFile.service';
import { paths } from 'src/component-paths/component-paths';

@Component({
    selector: 'app-laboratory-section',
    templateUrl: './laboratory-section.component.html',
    styleUrls: ['./laboratory-section.component.css'],
    standalone: false
})
export class LaboratorySectionComponent {
  @Input() submenu?: IModule[];
  componentPaths = paths;

  @Input() selectedOption?: string;
  @Output() selectedOptionChange = new EventEmitter<string>();

  ngOnInit() {}

  private scrollSubject = new Subject<Event>();

  ngAfterViewInit() {
    setTimeout(() => {
      combineLatest([
        this.laboratoryFileService.laboratoryLoadingSub$,
      ]).subscribe(([value1]) => {
        const sectionPath = this.submenu?.find(
          (sm) => sm.path == this.selectedOption
        )?.path;
        if (!value1 && sectionPath) {
          const element = document.getElementById(sectionPath);
          if (element) {
            // menu, patient header, title, margin
            const offset = element.offsetTop - 120 - 66 - 64 - 16;
            window.scroll({
              top: offset,
              behavior: 'smooth',
            });

            this.scrollSubject
              .pipe(
                debounceTime(100) // Adjust debounce time as needed (in milliseconds)
              )
              .subscribe(() => {
                // Your existing scroll logic here
                const lf = document.getElementById(paths.laboratoryFiles);
                const lr = document.getElementById(paths.laboratoryResults);

                if (lr) {
                  const rect = lr.getBoundingClientRect();
                  if (rect.top >= 120) {
                    this.selectedOption = this.submenu?.find(
                      (sm) => sm.path == paths.laboratoryResults
                    )?.path;

                    this.selectedOptionChange.emit(this.selectedOption);
                  }
                }

                if (lf) {
                  const rect = lf.getBoundingClientRect();
                  if (rect.top >= 120) {
                    this.selectedOption = this.submenu?.find(
                      (sm) => sm.path == paths.laboratoryFiles
                    )?.path;

                    this.selectedOptionChange.emit(this.selectedOption);
                  }
                }
              });
          }
        }
      });
    }, 500);
  }

  constructor(private readonly laboratoryFileService: LaboratoryFileService) {}

  @HostListener('window:scroll', ['$event'])
  onScroll(event: Event): void {
    this.scrollSubject.next(event);
  }
}
